import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import type { Option } from 'shared/components/ContextMenu/types'
import type { TagItem } from '../../types/tags.types'

export type TagProps = {
	tag: TagItem
	menuOptions: Option[]
}

export const Tag = ({ tag, menuOptions }: TagProps) => {
	const { t } = useTranslation()

	return (
		<li className="flex items-start justify-between gap-3 p-4">
			<p className="min-w-0 text-[13px] font-semibold text-foreground">{tag.name}</p>
			<ContextMenu
				dataId={tag.id}
				item={tag}
				options={menuOptions}
				label={t('Actions for {{ name }}', { name: tag.name })}
			/>
		</li>
	)
}
